<template>
	<div class="main-containter" id="top" v-title data-title="和华利盛">
		<FHeader :checkId="28"></FHeader>
		<FOtherBanner :name1="'联系我们'" :name2="'Contact Us'"></FOtherBanner>
		<!-- <FTitle></FTitle> -->
		<article style="height: 100%;">
			<div style="padding-left: 18%;padding-top: 20px;">
				<el-breadcrumb separator="/">
				<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
				<el-breadcrumb-item style="color:black">联系我们</el-breadcrumb-item>
			</el-breadcrumb>
			</div>
			<div style="width: 64%;padding: 30px 18%;margin-top:50px;">
				<div style="text-align: center;">
					<div style="font-size: 26px;font-weight: 900;color: #98273A;">联系我们</div>
					<div style="padding-top: 5px;font-size: 14px;color: #98273A;">Contact Us</div>
				</div>
				<div v-for="(item,index) in list" :key="index" style="height:500px;margin-top:25px;">
					<div style="float: left;width: 50%;padding-top: 40px;background-color: #F8F8F8;margin-top: 40px;height: 85%;">
						<div style="margin-left: 30px;">
							<span style="font-size: 24px;font-weight: 800;color: #98273A;margin-right: 10px;">{{item.name}}</span>
							<span style="font-size: 14px;color: #333333;">/{{item.ename}}</span>
						</div>
						<div style="margin-left: 30px;height: 4px;margin-bottom: 10px;margin-top: 10px;width: 18px;background-color: #98273A;"></div>
						<div style="padding-left: 30px;margin-top: 20px;">
							<img style="width: calc(100% - 30px);" :src="item.img">
						</div>
					</div>
					<div style="float:right;width:45%;margin-left:5%;margin-top:120px;">
						<div style="height: 2px;margin-bottom: 10px;margin-top: 10px;width: 50px;background-color: #98273A;"></div>
						<div style="width: 100%;margin-top: 20px;padding-top: 40px;border-top: 1px solid #DFDFDF;">
							<!-- <div style="float:left;">
								<img style="width: 75px;height: 75px;padding: 5px;border: 1px solid #DFDFDF;" :src="item.linkImg">
								<div style="font-size: 14px;text-align: center;margin-top: 10px;">二维码名片</div>
							</div> -->
							<!-- <div style="float: left;margin-left: 40px;"> -->
							<div>
								<div>
									<img style="width: 15px;height: 15px;vertical-align: middle;margin-right: 4px;" src="../../assets/fImage/地址.png">
									<span style="margin-left: 15px;color: #595959;font-size: 14px;">{{item.address}}</span>
								</div>
								<div style="margin-top: 20px;">
									<img style="width: 15px;height: 15px;vertical-align: middle;margin-right: 4px;" src="../../assets/fImage/邮箱3.png">
									<span style="margin-left: 15px;color: #595959;font-size: 14px;">{{item.email}}</span>
								</div>
								<div style="margin-top: 20px;">
									<img style="width: 15px;height: 15px;vertical-align: middle;margin-right: 4px;" src="../../assets/fImage/电话.png">
									<span style="margin-left: 15px;color: #595959;font-size: 14px;">{{item.phone}}</span>
								</div>
								<!-- <div style="margin-top: 20px;">
									<img style="width: 15px;height: 15px;vertical-align: middle;margin-right: 4px;" src="../../assets/fImage/电话.png">
									<span style="margin-left: 15px;color: #595959;font-size: 14px;">{{item.fax}}</span>
								</div> -->
								
							</div>
						</div>
					</div>
				</div>
				<div style="margin-top:100px;">
					<div style="text-align: center;font-size: 22px;">快速提交您的请求</div>
					<div style="width: 100%;height: 70px;margin-top: 30px;">
						<div style="float: left;width: calc(48% - 2px);margin-right: 2%;">
							<input v-model="name" style="width: 100%;height: 50px;line-height: 50px;padding-left: 15px;border-radius: 10px;border: 1px solid #797979;" type="text" placeholder="请输入您的姓名">
						</div>
						<div style="float: left;width: calc(48% - 2px);margin-left: 2%;">
							<input v-model="email" style="width: 100%;height: 50px;line-height: 50px;padding-left: 15px;border-radius: 10px;border: 1px solid #797979;" type="text" placeholder="请输入您的电子邮箱">
						</div>
					</div>
					<div style="width: 100%;height: 70px;margin-top: 30px;">
						<div style="float: left;width: calc(48% - 2px);margin-right: 2%;">
							<input v-model="phone" style="width: 100%;height: 50px;line-height: 50px;padding-left: 15px;border-radius: 10px;border: 1px solid #797979;" type="text" placeholder="请输入您的联系方式">
						</div>
						<div style="float: left;width: calc(48% - 2px);margin-left: 2%;">
							<input v-model="area" style="width: 100%;height: 50px;line-height: 50px;padding-left: 15px;border-radius: 10px;border: 1px solid #797979;" type="text" placeholder="请输入您的所在城市">
						</div>
					</div>
					<div style="width: 100%;height: 180px;margin-top: 30px;">
						<textarea v-model="desc" style="width: 100%;padding-left: 15px;border-radius: 10px;border: 1px solid #797979;padding-top: 20px;" rows="8" cols="100" placeholder="请详细描述您请求的内容">
							
						</textarea>
					</div>
					<div @click="submit()" style="cursor: pointer;font-size: 14px;text-align: center;border-radius: 7px;width: 70px;margin-bottom: 70px;color: white;padding: 10px 25px;background-color: #98273A;">提交请求</div>
				</div>
			</div>
		</article>
		<Footer></Footer>
	</div>
</template>

<script>
	import {create,query} from "@/api/leaveMassage";
	import FHeader from "../../components/f/FHeader.vue"
	import FOtherBanner from "../../components/f/FOtherBanner.vue"
	import Footer from "../../components/f/Footer.vue"
	export default {
		name: "Index",
		components: {
			FHeader,
			FOtherBanner,
			Footer
		},
		data() {
			return {
				list:[
					{name:'上海',ename:'Shanghai',img:'https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/%E5%94%90%E5%B1%B1%E5%9B%BE%E7%89%87.png',linkImg:'https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/%E4%BA%8C%E7%BB%B4%E7%A0%81.png',address:'上海市徐汇区肇嘉浜路1065号飞雕国际大厦1509室',email:'shanghai@hehualawyer.com',phone:'021-63331010',fax:'传真传真传真传真'},
					{name:'重庆',ename:'ChongQing',img:'https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/%E5%94%90%E5%B1%B1%E5%9B%BE%E7%89%87.png',linkImg:'https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/%E4%BA%8C%E7%BB%B4%E7%A0%81.png',address:'重庆市渝中区大坪正街19号英利中心壹号14楼',email:'chongqin@hehualawyer.com',phone:'15683834405',fax:'传真传真传真传真'},
					{name:'西安',ename:'XiAn',img:'https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/%E5%94%90%E5%B1%B1%E5%9B%BE%E7%89%87.png',linkImg:'https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/%E4%BA%8C%E7%BB%B4%E7%A0%81.png',address:'西安市高新区唐延路11号禾盛京广中心E座2802室',email:'xian@hehualawyer.com',phone:'029-81773628/13389256128',fax:'传真传真传真传真'},
					{name:'唐山',ename:'Tangshan',img:'https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/%E5%94%90%E5%B1%B1%E5%9B%BE%E7%89%87.png',linkImg:'https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/%E4%BA%8C%E7%BB%B4%E7%A0%81.png',address:'河北省唐山市路北区建设北路96-1号',email:'tangshan@hehualawyer.com',phone:'0315-2037777',fax:'传真传真传真传真'},
					{name:'郑州',ename:'ZhengZhou',img:'https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/%E5%94%90%E5%B1%B1%E5%9B%BE%E7%89%87.png',linkImg:'https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/%E4%BA%8C%E7%BB%B4%E7%A0%81.png',address:'河南省郑州市郑东新区CBD商务内环路2号6层605号、606号',email:'zhengzhou@hehualawyer.com',phone:'0371-63226691',fax:'传真传真传真传真'},
					{name:'海口',ename:'HaiKou',img:'https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/%E5%94%90%E5%B1%B1%E5%9B%BE%E7%89%87.png',linkImg:'https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/%E4%BA%8C%E7%BB%B4%E7%A0%81.png',address:'海南省海口市美兰区富力首府富力中心2508室',email:'haikou@hehualawyer.com',phone:'18136135075',fax:'传真传真传真传真'},
					{name:'太原',ename:'TaiYuan',img:'https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/%E5%94%90%E5%B1%B1%E5%9B%BE%E7%89%87.png',linkImg:'https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/%E4%BA%8C%E7%BB%B4%E7%A0%81.png',address:'山西省太原市万柏林区滨河西路（南段）85号1幢A座9层',email:'taiyuan@hehualawyer.com',phone:'0351-6079116',fax:'传真传真传真传真'},
					{name:'合肥',ename:'HeFei',img:'https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/%E5%94%90%E5%B1%B1%E5%9B%BE%E7%89%87.png',linkImg:'https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/%E4%BA%8C%E7%BB%B4%E7%A0%81.png',address:'合肥所地址安徽省合肥市瑶海区当涂北路16号科硕大厦801室',email:'shaodongming@hehualawyer.com',phone:'14792368699 ',fax:'传真传真传真传真'},
					{name:'和华启核',ename:'HeHuaQiHe',img:'https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/%E5%94%90%E5%B1%B1%E5%9B%BE%E7%89%87.png',linkImg:'https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/%E4%BA%8C%E7%BB%B4%E7%A0%81.png',address:'上海市徐汇区肇嘉浜路1065号飞雕国际大厦1203室',email:'VCYu@coipcore.com',phone:'18621693420',fax:'传真传真传真传真'},
				],
				name:'',
				email:'',
				phone:'',
				area:'',
				desc:''
			}
		},
		mounted() {
			document.getElementById("top").scrollIntoView({ behavior: "smooth" });
		},
		activated(){
			document.getElementById("top").scrollIntoView({ behavior: "smooth" });
		},
		
		watch: {
		},
		methods: {
			submit(){
				if(!this.name){
					this.$message.error('请输入您的姓名')
				}else if(!this.phone){
					this.$message.error('请输入您的联系方式')
				}else if(!this.email){
					this.$message.error('请输入您的电子邮箱')
				}else if(!this.city){
					this.$message.error('请输入您的所在城市')
				}else if(!this.content){
					this.$message.error('请详细描述您请求的内容')
				}else{
					let param = {}
					param.name = this.name;
					param.phone = this.phone;
					param.email = this.email;
					param.city = this.area;
					param.content = this.desc;
					create(param).then(data => {
						this.$message.success("提交成功!")
						this.name = ''
						this.phone = ''
						this.email = ''
						this.area = ''
						this.desc = ''
					}).catch(error => {
						this.$message.error(error)
					})
				}
			},
		}
	}
</script>
<style lang="scss" scoped="scoped">

	span /deep/ .el-breadcrumb__inner{
		font-weight: 400 !important;
		color: #606266 !important;
		cursor: default !important;
	}
	span /deep/ .el-breadcrumb__inner.is-link{
		font-weight: 400 !important;
		color: #606266 !important;
		cursor: pointer !important;
	}
div /deep/ .el-pagination.is-background .btn-next:disabled{
    margin: 0 5px;
    background-color: white !important;
    min-width: 30px;
    border-radius: 2px !important;
    font-weight: 400 !important;
    border: 1px solid #D9D9D9 !important;
		color: #C3C3C7 !important;
}
div /deep/ .el-pagination.is-background .btn-prev:disabled{
    margin: 0 5px;
    background-color: white !important;
    min-width: 30px;
    border-radius: 2px !important;
    font-weight: 400 !important;
    border: 1px solid #D9D9D9 !important;
		color: #C3C3C7 !important;
}
div /deep/ .el-pagination.is-background .btn-prev{
    /*进行修改未选中背景和字体*/
    margin: 0 5px;
    background-color: white !important;
    color: #606266 !important;
    min-width: 30px;
    border-radius: 2px !important;
    font-weight: 400 !important;
    border: 1px solid #D9D9D9 !important;
}
div /deep/ .el-pagination.is-background .btn-next{
    /*进行修改未选中背景和字体*/
    margin: 0 5px;
    background-color: white !important;
    color: #606266 !important;
    min-width: 30px;
    border-radius: 2px !important;
    font-weight: 400 !important;
    border: 1px solid #D9D9D9 !important;
}
div /deep/ .el-pagination.is-background .el-pager li{
    /*进行修改未选中背景和字体*/
    margin: 0 5px;
    background-color: white !important;
    color: #606266 !important;
    min-width: 30px;
    border-radius: 2px !important;
    font-weight: 400 !important;
    border: 1px solid #D9D9D9 !important;
}

div /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
  /*进行修改选中项背景和字体*/
	background-color: #98273A !important;
  color:white !important;
  border-radius: 2px !important;
  font-weight: 400 !important;
  border: 1px solid #98273A !important;
}

div /deep/ .el-pagination.is-background .el-pager li:hover{
   color: #98273A !important;/*hover时候的文字颜色*/
 }
div /deep/ .el-pager li.active{
   color:#98273A !important;/*仅设置active时的文字颜色*/
 }
div /deep/ .el-pagination{
	text-align: center;
}
</style>
